import { useTranslation } from 'react-i18next';

import { useTheme } from '../theme/ThemeProvider';

export function ThemeToggle({ compact = false }: { compact?: boolean }) {
  const { mode, toggle } = useTheme();
  const { t } = useTranslation();
  const label = mode === 'light' ? t('common.themeDark') : t('common.themeLight');

  return (
    <button
      type="button"
      className={`btn btn--ghost${compact ? ' btn--icon' : ''}`}
      onClick={toggle}
      aria-label={`${t('common.theme')}: ${label}`}
      title={`${t('common.theme')}: ${label}`}
    >
      <span aria-hidden="true">{mode === 'light' ? '🌙' : '☀️'}</span>
      {!compact && <span>{label}</span>}
    </button>
  );
}
